module.exports = __webpack_public_path__ + "img/band_length.c85436f3.png";